import angular from 'angular';
import BoxPostByCategoryComponent from './box-post-by-category.component';

let BoxPostByCategoryModule = angular.module('catalog.productsModules.boxPostByCategory', [])
  .component('boxPostByCategory', BoxPostByCategoryComponent);

export default BoxPostByCategoryModule;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/box-post-by-category/box-post-by-category.js
 **/